import { render, staticRenderFns } from "./textEditor.vue?vue&type=template&id=f2c1f022&"
import script from "./textEditor.vue?vue&type=script&lang=js&"
export * from "./textEditor.vue?vue&type=script&lang=js&"
import style0 from "./textEditor.vue?vue&type=style&index=0&id=f2c1f022&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports